<template>
  <div>
    <el-table v-if="flowFileList.length > 0 && routerParams.flowKey !== 'publish'" :data="flowFileList" :show-header="false" max-height="200px">
      <el-table-column label="名称" prop="name">
        <template slot-scope="scope">
          <div class="nameStyle">
            <fileLightFlag v-if="routerParams.flowStatus&&routerParams.status" :row="scope.row" :form-flow="true"
              @updateLight="updateLight" />
            <div class="fileNameStyle">
              <img v-if="scope.row.isFolder != 1" :src="className(scope.row)" class="img" alt="" />
              <img v-else :src="icon" class="img" alt="" />
              <span v-if="scope.row.isRead === 1 && routerParams.flowKey === 'check'"
                style="cursor: pointer; color: var(--theme-color)" @click="preview(scope.row)">{{ scope.row.fileName }}</span>
              <span v-else-if="scope.row.isRead === 0 && routerParams.flowKey === 'check'" style="cursor: pointer;"
                @click="preview(scope.row)">{{ scope.row.fileName }}</span>
              <span v-else style="cursor: pointer;" @click="preview(scope.row)">{{ scope.row.fileName }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="120px">
        <template slot-scope="scope">
          <span class="midd-table">
            <i class="el-icon-download" title="下载" style="margin-right: 15px; color: var(--theme-color)"
              @click="downLoadFile(scope.row)" />
            <!-- 流程驳回、撤回后再发起，rvt端上传的视图文件不能删除 -->
            <i v-if="(!routerParams.flowStatus&&scope.row.uploadType!==3)||!routerParams.status" class="el-icon-delete"
              title="删除" style="color: #f54f45" @click="deleteRow(scope.$index, scope.row)" />
          </span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 出版流程 -->
    <div v-if="flowFileList.length > 0 && routerParams.flowKey == 'publish'" class="publishFileStyle">
      <div v-for="(item, index) in flowFileList" :key="index" class="fileName" :class="[item.parentFileId?'childStyle':'pStyle']">
        <div class="fileNameBox">
          <fileLightFlag v-if="routerParams.flowStatus&&routerParams.status" :row="item" :form-flow="true"
            @updateLight="updateLight" />
          <img v-if="item.isFolder != 1" :src="className(item)" class="img" alt="" />
          <img v-else :src="icon" class="img" alt="" />
          <div class="fileNameStyle" @click="preview(item)">{{ item.fileName }}</div>
        </div>
        <div>
          <i class="el-icon-download" title="下载" style="margin-right: 15px; color: var(--theme-color);cursor: pointer;"
            @click="downLoadFile(item)" />
          <i v-if="!routerParams.flowStatus||!routerParams.status" class="el-icon-delete"
            title="删除" style="color: #f54f45;cursor: pointer;" @click="publishDeleteFile(index, item)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { tableRowIcon, noLabelFilePreview, common2D3DFileType } from "@/CommonDP/utils/docPublic";
import flowService from "@/CommonDP/service/flow-service";
import xtDesign from "@/CommonDP/service/integratedModel-service";
import { downloadFile, flowFileDownLoad } from "@/CommonDP/utils";
import fileLightFlag from "@/CommonDP/components/fileLightFlag";
import docService from "@/CommonDP/service/doc-service";
import XtDesignService from "@/CommonDP/service/XtDesign-service";

export default {
  components: { fileLightFlag },
  props: {
    files: {
      type: Array,
      default: () => []
    },
    rvtFileList: {
      type: Array,
      default: () => []
    },
    rvtViewsList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      flowFileList: []
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      floderObj: state => state.uploaderLocal.floderObj,
      enterpriseId: state => state.enterprise.enterpriseId,
      routerParams: state => state.projectMg.routerParams,
      userInfo: state => state.user.userInfo
    }),
    // cad跳转样式
    showBar() {
      if (window.location.href.indexOf("jsName=BimEx") !== -1) {
        return false;
      } else {
        return true;
      }
    },
    // rvt跳转样式
    isRVT() {
      if (window.location.href.indexOf("jsName=BimExRVT") !== -1) {
        return false;
      } else {
        return true;
      }
    }
  },
  watch: {
    floderObj(newValue) {
      if (newValue.fileId) {
        // 本地上传改成1 uploader组件上传有问题
        if (newValue.uploadType === "4") {
          newValue.uploadType = 1;
        }
        this.filesRepeating([newValue]);
      }
    },
    async files(newValue) {
      this.filesRepeating(newValue);
    },
    rvtFileList(newValue) {
      this.setRvtFileInfoList(newValue);
    }
  },

  methods: {
    refresh() {
      const noSuccessfileList = this.flowFileList.filter((item) => (item.status != 2 && item.status != 6) &&
      common2D3DFileType(item));
      noSuccessfileList.forEach(async ele => {
        const { data } = await XtDesignService.getFileDetails(ele.fileId);
        this.$set(ele, 'status', data.status);
      });
    },
    updateLight(row, type) {
      const prjId = this.enterpriseId;
      row.status = "1";
      const status = row.status;
      let messageType;
      type === 1 ? (messageType = "优先轻量化操作") : (messageType = "重新轻量化操作");
      docService
        .updateLight(prjId, row.fileId, row.fileVersion)
        .then(res => {
          if (res.result === "0") {
            row.status = "1";
            this.$message.success(`${messageType}成功`);
          } else {
            row.status = status;
            this.$message.warning(`${messageType}失败`);
          }
        })
        .catch(() => {
          row.status = status;
        });
    },
    // 设置文件路径
    setFilePath() {
      if (this.flowFileList.length) {
        this.flowFileList.forEach(async (item, index) => {
          item.paths = [];
          item.pathName = "";
          if (item.uploadType == 2) {
            const res = await flowService.getAssociatedFileLocation(item.fileId);
            const location = res.data || [];
            if (location.length) {
              item.paths = location.map(folder => folder.folderId);
              location.forEach(element => {
                item.pathName = item.pathName + element.folderName + "/";
              });
              if (item.pathName) {
                item.pathName = item.pathName.substring(0, item.pathName.length - 1);
              }
            }
          }
        });
      }
    },
    // 跳转到项目文件，打开文件所在文件夹
    async toProjectDoc(paths) {
      const prjId = this.routerParams.prjId || this.prjInfo?.prjId;
      const result = await flowService.getProjectUsers(prjId);
      const users = result.data || [];
      const exist = users.filter(item => item.userId == this.userInfo.userId);
      if (!exist || !exist.length) {
        this.$message.warning("当前用户不在该项目内");
        return;
      }
      const res = await flowService.viewList(prjId);
      this.$store.dispatch("updatePrj", res.data);
      this.$router.push({
        path: "/project-XtDesign",
        query: { paths: paths }
      });
    },

    async filesRepeating(newValue) {
      const arr1 = newValue;
      const arr2 = this.flowFileList;
      const arr1fileNames = new Set(arr1.map(({ fileName }) => fileName));
      const isfloderData = [...arr1, ...arr2.filter(({ fileName }) => !arr1fileNames.has(fileName))];
      this.flowFileList = isfloderData;
      const isnotfloderData = [...arr2.filter(({ fileName }) => arr1fileNames.has(fileName))];
      for (const key in isnotfloderData) {
        setTimeout(() => {
          this.$message.warning(`${isnotfloderData[key].fileName}上传失败，已存在同名文件`);
        }, 10);
      }
    },
    setRvtFileInfoList(newValue) {
      let arr1 = [];
      let arr2 = [];
      if (!this.rvtViewsList.length) {
        arr1 = [];
        arr2 = this.flowFileList.filter(ele => ele.uploadType !== 3);
        this.flowFileList = this.flowFileList.filter(ele => ele.uploadType !== 3);
      } else {
        const list = this.flowFileList.filter(ele => ele.uploadType === 3);
        if (!list.length) {
          // 说明是第一次添加视图文件
          arr1 = newValue;
          arr2 = this.flowFileList;
        } else {
          arr1 = newValue;
          const list = this.flowFileList.filter(ele => ele.uploadType === 3);
          this.flowFileList = this.flowFileList.filter(ele => ele.uploadType !== 3);
          newValue.forEach(ele => {
            list.forEach(res => {
              if (res.fileId === ele.fileId) {
                arr2 = this.flowFileList.push(res);
              }
            });
          });
          arr2 = this.flowFileList;
        }
      }
      const arr1fileNames = new Set(arr1.map(({ fileName }) => fileName));
      const isfloderData = [...arr1, ...arr2.filter(({ fileName }) => !arr1fileNames.has(fileName))];
      this.flowFileList = isfloderData;
      const isnotfloderData = [...arr2.filter(({ fileName }) => arr1fileNames.has(fileName))];
      // for (const key in isnotfloderData) {
      //   setTimeout(() => {
      //     this.$message.warning(`${isnotfloderData[key].fileName}上传失败，已存在同名文件`);
      //   }, 10);
      // }
    },
    // 接口：设置文件列表
    setFileList(fileList) {
      this.flowFileList = fileList || [];
    },

    // 接口：获取文件列表
    getFileList() {
      return this.flowFileList || [];
    },

    // 文件预览打开,文件变色
    async preview(row) {
      const params = {
        flowBusinessId: this.routerParams.flowBusinessId,
        fileId: row.fileId,
        fileName: row.fileName
      };
      const res = await flowService.readFlowFile(params);
      if (res.result === "0") row.isRead = 1;
      this.onLineView(row);
    },

    async onLineView(row) {
      const value = {
        folderId: row.fileId,
        folderName: row.fileName,
        parentId: row.parentId,
        fileVersion: row.versionIds || 1,
        fileType: Number(row.fileType),
        status: row.status
      };
      if (value.status === 2) {
        value.status = value.status.toString();
      }

      const prjId = this.routerParams.prjId || this.prjInfo.prjId;
      // 获取当前项目的名称
      const prjList = await this.getprjList();
      const prj = prjList.find(item => item.prjId === prjId);
      const prjName = prj?.prjName || "";
      const flowInstanceId = this.routerParams.flowInstanceId || '';
      const obj = {
        fileId: row.fileId,
        // fileNames: row.fileName,
        prjId,
        // prjName,
        status: row.status,
        versionIds: row.versionIds || 1,
        fileType: Number(row.fileType),
        source: "ct",
        flowInstanceId
      };
      if (obj.status === 2) {
        obj.status = obj.status.toString();
      }
      const noNeedIssue = this.routerParams.flowKey === "check" ? true : '';
      // web端用value CAD端用obj
      // 判断是否为cad、revit打开的
      if (!this.showBar || !this.isRVT) {
        console.log('为cad、revit打开的');
        obj.noNeedIssue = noNeedIssue;
        await CefSharp.BindObjectAsync("cefSharpBrower");
        cefSharpBrower.openUrl(JSON.stringify(obj));
      } else {
        console.log("为web打开的");
        noLabelFilePreview(value, prjId, prjName, "ct", noNeedIssue, "", flowInstanceId);
      }
    },
    downLoadFile(row) {
      const fileId = row.fileId;
      const versionIds = row.versionIds;
      const url = flowFileDownLoad(this.routerParams.flowInstanceId, fileId, versionIds);
      downloadFile(url);
    },
    deleteRow(index) {
      const res = new Map();
      this.flowFileList = this.flowFileList.filter(a => !res.has(a.fileName) && res.set(a.fileName, 1));
      const currentViewObj = this.flowFileList.find((ele, currentIndex) => currentIndex === index);
      this.flowFileList.splice(index, 1);
      // 如果是revit端的话还得删除表单里的对应的视图
      if (this.routerParams.clientType === 2 && this.routerParams.startFlowMode === 1) {
        if (currentViewObj.uploadType === 3) this.$emit("deleViewList", currentViewObj);
      }
    },
    publishDeleteFile(index, val) {
      const res = new Map();
      this.flowFileList = this.flowFileList.filter(a => !res.has(a.fileName) && res.set(a.fileName, 1));
      this.flowFileList.forEach((ele) => {
        if (ele.parentFileId === val.fileId) { this.$set(eleChild, 'parentFileId', ''); }
      });
      this.flowFileList.splice(index, 1);
    },

    className(row) {
      return tableRowIcon(row);
    },
    async getprjList() {
      const param = {
        enterpriseId: this.routerParams.enterpriseId || this.enterpriseId
      };
      const res = await xtDesign.queryPrj(param);
      const prjList = res.data;
      return prjList;
    }
  }
};
</script>

<style lang="scss" scoped>
.nameStyle{
  display: flex;
  align-items: center;
  .img{
    flex-shrink:0;
    margin:0 5px;
  }
  .fileNameStyle{
    display: flex;
    align-items: center;
    position: absolute;
    width: 100%;
    left:21px
  }
}
.midd-table {
  width: 100%;
  display: flex;
  .el-icon-download {
    margin-right: 15px;
    color: var(--theme-color);
    cursor: pointer;
    font-size: 16px;
  }
  .el-icon-delete {
    color: #f54f45;
    cursor: pointer;
  }
  .el-icon-key,
  .el-icon-unlock {
    cursor: pointer;
    color: var(--theme-color);
    font-size: 16px;
  }
}
.publishFileStyle{
  .fileName{
    display: flex;
    align-items: center;
    height: 35px;
    margin-bottom:5px;
    justify-content: space-between;
  }
  .fileNameBox{
    display: flex;
    align-items: center;
    position:relative;
    width: 100%;
  }
  .pStyle{
    background:#aaaaaa1a;
    padding: 0px 5px;
  }
  .childStyle{
    background:#aaaaaa0f;
    padding: 0px 5px 0px 13px;
  }
  .img{
    flex-shrink:0;
    margin:0 5px;
    position: absolute;
    left:13px
  }
  .fileNameStyle{
    cursor: pointer;
    position: absolute;
    left:45px
  }
}
</style>
